import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { Documento } from "../../../types/processo/Documento";
import { Processo } from "../../../types/processo/Processo";


const endpointUrl = configUrls.PROCESSO_GERAR_DOCUMENTO_EP





function createDocumento(obj: Documento) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateDocumento(obj: Documento) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteDocumento({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}

function getDocumentosByProcesso(processo: Processo){
    return {
        url: `${endpointUrl}/processo/${processo.id}`,
        method: "GET",       
    }
}




export const documentoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getDocumento: query<Documento, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["Documento"],
        }),

        getDocumentosByProcesso: query<Documento[], Processo>({
            query: getDocumentosByProcesso,
            providesTags: ["Documento"],
        }),

        createDocumento1: mutation<Documento, Documento>(
            {
                query: createDocumento,
                invalidatesTags: ["Documento"]
            }),


        createDocumento: mutation<Documento, Documento>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,  // Usando a variável endpointUrl diretamente
                    method: 'POST',    // Método POST para criar o documento
                    body: obj,         // Corpo da requisição com os dados do novo documento
                }),
                invalidatesTags: ["Documento"]
            }),

        updateDocumento: mutation<Documento, Documento>({
            query: updateDocumento,
            invalidatesTags: ["Documento"]
        }),

        deleteDocumento: mutation<Documento, { id: string }>(
            {
                query: deleteDocumento,
                invalidatesTags: ["Documento"],
            }),


    }),

});
export const {
    useGetDocumentoQuery,
    useGetDocumentosByProcessoQuery,
    useCreateDocumentoMutation,
    useUpdateDocumentoMutation,
    useDeleteDocumentoMutation,
    useCreateDocumento1Mutation,
} = documentoApiSlice